<template>
    <div class="common-body-view">
        <div  class="common-title">
            <div @click="back" style="width: 30px;height: 30px;display: flex;align-items: center;justify-content: center;">
                <img src='../img/left.png' style="width: 14px; height: 14px;">
            </div>

            <span class="common-title-text">我的方案</span>
        </div>

        <div class="main">
            <div class="main-body">
                <div v-if="planList.length > 0">
                    <div v-for="(item,index) in planList" style="display: flex;align-items: center;justify-content: space-between;padding: 15px 0;border-bottom: 1px solid #ececec;">
                        <div style="font-size: 26px;font-weight: bold;color: #333333;width: 35px;padding-left: 5px;">{{index + 1}}</div>
                        <div style="flex: 1;">
                            <div style="font-size: 14px;color: #333333;font-weight: bold;">
                                {{item.name}}
                            </div>
                            <div style="font-size: 12px;color: #FFFFFF;text-align: right;margin-top: 8px;user-select: none;">
                                <span @click="deletePlan(index)" style="background-color: #b7b7b7;padding: 5px 10px;border-radius: 4px;cursor: pointer;margin-right: 10px;">
                                    删除
                                </span>
                                <span @click="enablePlan(index)" style="background-color: #0f78e8;padding: 5px 10px;border-radius: 4px;cursor: pointer;margin-right: 5px;">
                                    启用
                                </span>

                            </div>
                        </div>
                    </div>
                </div>

                <div v-else style="font-size: 14px;color: #888888;margin-top: 30px;text-align: center;">
                    还没有连点方案，赶紧去创建一个吧。
                </div>

            </div>

            <div style="width: 100%; display: flex;justify-content: space-between;height: 30px;padding: 0 15px;box-sizing: border-box;">

                <van-button  @click="createPlan" type="info" :loading="showLoading" style="height: 30px;width: 150px;font-size: 13px;" color="#0f78e8">
                    创建新的方案
                </van-button>
            </div>

        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Toast,Dialog } from 'vant';

    export default {
        name: "auto-click-setting",
        components: {
        },
        data() {
            return {
                showLoading: false,
                parent: this.$parent.$parent,
                planList: [],
            }
        },
        mounted () {
            this.planList = JSON.parse(localStorage.getItem('autoClickPlanList')) || [];
        },
        methods: {
            back(){
                this.parent.autoClickListShow = false;
            },
            createPlan() {
                this.parent.createNewAutoClickPlan();
            },
            enablePlan(index) {
                this.parent.enableAutoClickPlan(index);
            },
            deletePlan(index) {
                Dialog.confirm({
                    message: '确认要删除该方案吗?',
                }).then(() => {
                    this.planList.splice(index, 1);
                    localStorage.setItem('autoClickPlanList', JSON.stringify(this.planList));
                    Toast('方案删除成功');

                }).catch(() => {
                });
            },

        }
    }
</script>

<style scoped>
    .common-body-view {
        background-color: #f0f0f0;
        border-radius: 10px;
        width: 100%;
        height: 320px;
        box-sizing: border-box;
        max-width: 400px;
        position: relative;
        margin: 0 auto;
    }

    .common-title {
        height: 50px;
        display: flex;
        align-items: center;
        padding-right: 20px;
        padding-left: 5px;
    }

    .common-title-text {
        font-size: 14px;
        color: #444444;
        font-weight: bold;
        margin-left: 5px;
    }

    .main{
        width: 95%;
        height: 260px;
        background-color: #ffffff;
        border-radius: 5px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 5px 5px;
        box-sizing: border-box;
        position: relative;
    }
    .main-body {
        width: 100%;
        padding: 0 5px 15px;
        box-sizing: border-box;
        height: 230px;
        overflow-y: auto;
        text-align: left;
    }

    .main-body {
        -ms-overflow-style: none;  /* IE 和 Edge */
        scrollbar-width: none;/* Firefox */
    }
    .main-body::-webkit-scrollbar {
        display: none;/* 兼容 Chrome, Opera, 和 Safari */
    }

    .input-view{
        width: 100%;
        height: 38px;
        border-radius: 5px;
        display: flex;
        margin-top: 8px;
        border: 0.5px solid #e0e0e0;
        //box-shadow: 2px 2px 10px 3px rgba(0,0,0,.1);
    }
    .common-input {
        font-size: 14px;
        height: 38px;
        border-radius: 5px;
    }

    .van-cell {
        padding: 7px 10px;
    }
    /deep/ .van-field__control {
        color: #333333;
    }
    .van-cell::after {
        border-bottom: none;
    }

</style>